import React from "react"

// Ring-and-stars mark drawn after the Yva seal logo. Purely decorative.
const CENTER = 200

const polar = (radius, degrees) => {
  const radians = (degrees * Math.PI) / 180
  return [CENTER + radius * Math.cos(radians), CENTER + radius * Math.sin(radians)]
}

const starPoints = (cx, cy, outer) => {
  const points = []
  for (let i = 0; i < 10; i++) {
    const radius = i % 2 === 0 ? outer : outer * 0.42
    const radians = ((-90 + i * 36) * Math.PI) / 180
    points.push(`${(cx + radius * Math.cos(radians)).toFixed(1)},${(cy + radius * Math.sin(radians)).toFixed(1)}`)
  }
  return points.join(" ")
}

// Stars sweep clockwise from the top right to the bottom left, shrinking as they go
const STARS = [
  { angle: -62, size: 24 },
  { angle: -34, size: 23 },
  { angle: -6, size: 21 },
  { angle: 22, size: 19 },
  { angle: 48, size: 17 },
  { angle: 72, size: 15 },
  { angle: 95, size: 13 },
  { angle: 117, size: 11 },
  { angle: 138, size: 10 },
  { angle: 158, size: 9 }
]

const SealMark = ({ className }) => {
  const [arcStartX, arcStartY] = polar(182, 270)
  const [arcEndX, arcEndY] = polar(182, 175)

  return (
    <svg
      className={className}
      viewBox="0 0 400 400"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d={`M ${arcStartX} ${arcStartY} A 182 182 0 1 1 ${arcEndX} ${arcEndY}`}
        fill="none"
        stroke="currentColor"
        strokeWidth="14"
        strokeLinecap="round"
      />
      {STARS.map(({ angle, size }) => {
        const [x, y] = polar(138, angle)
        return <polygon key={angle} points={starPoints(x, y, size)} fill="currentColor" />
      })}
    </svg>
  )
}

export default SealMark
